import React, {Component} from 'react'
import PropTypes from 'prop-types'
import classNames from "classnames"
import {Tooltip} from "antd"

class Status extends Component {
    render() {
        const {status, message} = this.props
        const color = classNames({
            'pending progress-bar-animated progress-bar-striped': status === 'pending',
            'processing progress-bar-animated progress-bar-striped': status === 'processing',
            'failed': status === 'failed',
            'cancelled': status === 'cancelled',
            'done': status === 'done',
        })

        return (
            <td className="StatusJob">
                {
                    (status === 'cancelled' || status === 'failed') ?
                        <Tooltip title={message}>
                            <span className={`badge ${color} badge-pill`}>{status}</span>
                        </Tooltip>
                        : <span className={`badge ${color} badge-pill`}>{status}</span>
                }
            </td>
        )
    }
}

Status.propTypes = {
    message: PropTypes.string,
    status: PropTypes.string
}

export default Status